// import { TableLandingBorrowContainer } from "../../containers/borrowSystem/TableLandingBorrowContainer";
import { CheckBorrowSixContainer } from "../../containers/borrowSystem/CheckBorrowSixContainer"

export function CheckBorrowSixPage() {
    return (
        <CheckBorrowSixContainer />
    )
}